<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 21 21"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.3382 0.26795C10.7194 -0.089316 9.95705 -0.0893168 9.33825 0.267949L3.31586 3.74497C2.69706 4.10224 2.31586 4.76249 2.31586 5.47702L2.31586 13.9153C2.31586 14.4457 2.10515 14.9544 1.73008 15.3295L0.479631 16.5799C0.172528 16.887 0 17.3036 0 17.7379C0 18.6423 0.733161 19.3754 1.63756 19.3754H10.3383H19.0389C19.9433 19.3754 20.6765 18.6423 20.6765 17.7379C20.6765 17.3036 20.504 16.887 20.1969 16.5799L18.9464 15.3295C18.5713 14.9544 18.3606 14.4457 18.3606 13.9153V5.47703C18.3606 4.76249 17.9794 4.10224 17.3606 3.74497L11.3382 0.26795ZM8.73287 20.534H10.3381H11.9434C12.7421 20.534 13.2185 21.4241 12.7755 22.0887L11.7929 23.5625C11.6075 23.8407 11.2952 24.0078 10.9609 24.0078H9.7154C9.38105 24.0078 9.06882 23.8407 8.88335 23.5625L7.90082 22.0887C7.45779 21.4241 7.93418 20.534 8.73287 20.534Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: [Number, String], default: 21 },
    height: { type: [Number, String], default: 21 },
    color: { type: String, default: "#80b7ff" },
  },
};
</script>
